/* ============================================================
   SOLVEY · Free-gift card (Intimate Care Cream)
   ------------------------------------------------------------
   Injecteert één lichtgroene "free gift"-card in de Firmhouse
   Subscribe & Save card op alle PDP's, TUSSEN de bullets en de
   VIP-card (volgorde: bullets -> gift -> VIP). Zelfde resilience-
   pattern als solvey-vip-card.js:
   - body-class-onafhankelijk; werkt op elke PDP met een
     .selling_plan_app_container
   - MutationObserver + retry (Firmhouse rendert/re-rendert laat)
   - Eigen i18n (Weglot ziet Firmhouse-injected content niet
     betrouwbaar) — mirror van solvey-vip-card.js aanpak
   - Product-image komt uit window.SOLVEY_GIFT_CARD.image (Liquid,
     all_products) zodat 'ie meebeweegt als de owner de foto op het
     gift-product vervangt. Geen image -> geen card.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.SOLVEY_GIFT_CARD || {};
  if (!CFG.image) return; // niets te tonen zonder product-image

  // "Worth"-anchor + productnaam centraal (owner kan hier tweaken).
  var WORTH = CFG.worth || '€19,95';
  var TITLE = CFG.title || 'Solvey Intimate Care Cream';

  var LANGS = {
    pill: {
      en: 'Free with your subscription',
      nl: 'Gratis bij je abonnement',
      de: 'Gratis bei deinem Abo',
      da: 'Gratis med dit abonnement',
      fr: 'Offert avec votre abonnement'
    },
    // doorgestreept label vóór de prijs, bv. "Worth €19,95"
    worth: {
      en: 'Worth',
      nl: 'Twv',
      de: 'Wert',
      da: 'Værdi',
      fr: 'Valeur'
    },
    free: {
      en: 'Free — added to your cart',
      nl: 'Gratis — in je winkelmand',
      de: 'Gratis — im Warenkorb',
      da: 'Gratis — lagt i kurven',
      fr: 'Offert — ajouté au panier'
    }
  };

  var TARGET_SELECTOR = '.selling_plan_app_container li.subscription-card';
  var ROOT_SELECTOR = '.selling_plan_app_container';
  var VIP_SELECTOR = '.solvey-vip-card';
  var FLAG = 'data-solvey-gift-card';

  function currentLang() {
    if (window.Weglot && typeof window.Weglot.getCurrentLang === 'function') {
      var l = window.Weglot.getCurrentLang();
      if (l) return String(l).toLowerCase().split('-')[0];
    }
    if (window.Shopify && window.Shopify.locale) return String(window.Shopify.locale).toLowerCase().split('-')[0];
    if (document.documentElement.lang) return String(document.documentElement.lang).toLowerCase().split('-')[0];
    return 'nl';
  }

  function t(group, lang) {
    return LANGS[group][lang] || LANGS[group].en;
  }

  function buildCard(lang) {
    var card = document.createElement('div');
    card.className = 'solvey-gift-card';
    card.setAttribute(FLAG, 'true');
    card.innerHTML =
      '<div class="solvey-gift-card__plus" aria-hidden="true">+</div>' +
      '<img class="solvey-gift-card__img" src="' + CFG.image + '" alt="" loading="lazy" width="84" height="72">' +
      '<div class="solvey-gift-card__text">' +
        '<div class="solvey-gift-card__pill">' + t('pill', lang) + '</div>' +
        '<div class="solvey-gift-card__title wg-notranslate" data-wg-notranslate>' + TITLE + '</div>' +
        '<div class="solvey-gift-card__value">' +
          '<span class="solvey-gift-card__worth">' + t('worth', lang) + ' ' + WORTH + '</span>' +
          '<span class="solvey-gift-card__free">' + t('free', lang) + '</span>' +
        '</div>' +
      '</div>';
    return card;
  }

  function updateText(card, lang) {
    var pill = card.querySelector('.solvey-gift-card__pill');
    var worth = card.querySelector('.solvey-gift-card__worth');
    var free = card.querySelector('.solvey-gift-card__free');
    if (pill && pill.textContent !== t('pill', lang)) pill.textContent = t('pill', lang);
    var worthTxt = t('worth', lang) + ' ' + WORTH;
    if (worth && worth.textContent !== worthTxt) worth.textContent = worthTxt;
    if (free && free.textContent !== t('free', lang)) free.textContent = t('free', lang);
  }

  // Plaats de card altijd direct vóór de VIP-card als die er is; anders append.
  // (VIP-card append't zichzelf als laatste child -> zonder herplaatsing zou de
  // gift-card ná de VIP-card belanden bij een race.) Guard voorkomt observer-loop.
  function place(target, node) {
    var vip = target.querySelector(VIP_SELECTOR);
    if (vip) {
      if (node.nextElementSibling !== vip) target.insertBefore(node, vip);
    } else if (target.lastElementChild !== node) {
      target.appendChild(node);
    }
  }

  function apply() {
    var lang = currentLang();
    var targets = document.querySelectorAll(TARGET_SELECTOR);
    for (var i = 0; i < targets.length; i++) {
      var existing = targets[i].querySelector('.solvey-gift-card[' + FLAG + '="true"]');
      if (!existing) existing = buildCard(lang);
      else updateText(existing, lang);
      place(targets[i], existing);
    }
  }

  var debounce;
  function schedule() {
    clearTimeout(debounce);
    debounce = setTimeout(apply, 50);
  }

  function start() {
    apply();
    var root = document.querySelector(ROOT_SELECTOR);
    if (root && 'MutationObserver' in window) {
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    }
    if (window.Weglot && typeof window.Weglot.on === 'function') {
      try { window.Weglot.on('languageChanged', schedule); } catch (e) {}
    }
    window.addEventListener('pageshow', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Firmhouse rendert soms laat — retry kort.
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    apply();
    if (tries > 24) clearInterval(timer);
  }, 250);
})();
